import { DatePicker } from 'antd'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { CurrentDateSlice } from 'redux/reducers'
import { getProjectDateRange } from 'utils'
import { CalendarPicker, List } from 'antd-mobile'
import moment from 'moment'

export const DayNow = ({ projectData, setDate, date, type }) => {
    const [width, setWidth] = useState()
    const [mobilePicker, setMobilePicker] = useState(false)
    const dispatch = useDispatch()

    const onChange = date => {
        setDate(date)
        if (type === 'hse') {
            dispatch(CurrentDateSlice.actions.addCurrentHSEDate(date.format('YYYY-MM-DD')))
        } else {
            dispatch(CurrentDateSlice.actions.addCurrentDate(date.format('YYYY-MM-DD')))
        }
    }

    // 浏览器宽度发生变化时触发
    const resizeWidth = (e) => {
        const w = e.target.innerWidth
        setWidth(w)
    }

    useEffect(() => {
        const w = window.innerWidth
        setWidth(w)
        window.addEventListener("resize", resizeWidth)
        return () => {
            window.removeEventListener("resize", resizeWidth)
        }
    }, [])
    return (
        width < 960 ? <List>
            < List.Item
                onClick={() => {
                    setMobilePicker(true)
                }}
            >
                {moment(date)?.format('YYYY-MM-DD')}
                < CalendarPicker
                    visible={mobilePicker}
                    selectionMode='single'
                    value={date}
                    onClose={() => setMobilePicker(false)}
                    onMaskClick={() => setMobilePicker(false)}
                    onChange={date => setDate(moment(date))}
                    onConfirm={date => onChange(date)}
                />
            </ List.Item>
        </List >
            : <DatePicker
                className='date'
                value={date}
                onChange={onChange}
                allowClear={false}
                disabledDate={currentDate => {
                    if (!projectData) return
                    const { startDate, endDate } = getProjectDateRange(projectData, type)
                    const date = currentDate.format('YYYY-MM-DD')
                    return date < startDate || date > endDate
                }}
            />


    )
}
